import React, { useState } from "react";
import CompanyProfile from "../../Components/CompanyProfile/CompanyProfile";
import { FaRegListAlt, FaRegUser } from "react-icons/fa";
import SecurityProfile from "../../Components/SecurityProfile/SecurityProfile";
import SubscriptionProfile from "../../Components/SubscriptionProfile/SubscriptionProfile";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import { BsBuildings } from "react-icons/bs";
import { GiPadlock } from "react-icons/gi";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import { useSelector } from "react-redux";
import EmplyeeProfile from "../../Components/EmployeeProfile/EmplyeeProfile";

const Settings = () => {
  const { role, loginData } = useSelector(state => state.userReducer);

  const [activeTab, setActiveTab] = useState({
    name:
      role === "Employee"
        ? "Profile"
        : role === "Client"
        ? loginData?.clientData?.paymentStatus === "paid"
          ? "Company Profile"
          : "Subscriptions"
        : "Company Profile",
    visible: true,
  });

  const renderContent = () => {
    switch (activeTab?.name) {
      case "Profile":
        return <EmplyeeProfile />;
      case "Company Profile":
        return <CompanyProfile />;
      case "Security":
        return <SecurityProfile />;
      case "Subscriptions":
        return <SubscriptionProfile />;
      default:
        return null;
    }
  };

  const tabs = [
    { name: "Profile", visible: role === "Employee"},
    { name: "Company Profile", visible: role === "Client" || role === "Admin"},
    { name: "Security", visible: true },
    { name: "Subscriptions", visible: role === "Client" },
  ];
  console.log(loginData);

  return (
    <ParentComponent className="container mx-auto p-6">
      <PrimaryHeader
      // buttonText="Logout"
      // buttonIcon={<IoIosLogOut className="mr-2" />}
      // onButtonClick={() => navigate('/')}
      />

      <div className="flex space-x-8 mb-8">
        {tabs.map((tab) =>
          !tab.visible ? null : (
            <button
              key={tab.name}
              onClick={() => setActiveTab(tab)}
              className={`py-2  text-md flex flex-row items-center transition-all ${activeTab?.name === tab.name
                ? "border-b-4 border-[#361D32] text-[#361D32]"
                : "text-gray-600 hover:text-black border-white border-b-4"
                }`}
            >
               {tab.name === "Company Profile" ? (
                <BsBuildings className="w-5 h-5 mr-3" />
              ) : tab.name === "Profile" ? (
                <FaRegUser className="w-5 h-5 mr-3" />
              ) : tab.name === "Security" ? (
                <GiPadlock className="w-5 h-5 mr-3" />
              ) : tab.name === "Subscriptions" ? (
                <FaRegListAlt className="w-5 h-5 mr-3" />
              ) : null}

              {tab.name}
            </button>
          )
        )}
      </div>

      {renderContent()}
    </ParentComponent>
  );
};

export default Settings;
